/*
* 组织秘钥管理组件
* zxw
* 创建时间：
* 修改时间：2026-08-13
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    theme,
    message,
    Table,
    Select,
    Button,
    Space,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    CopyToClipboard,
    GetDropdownActionName,
    ShowIPModal,
} from '../../incs/FunHelper.js';

import Entity from './OrgApikeyEntity.js';

const MODULENAME = CNF.navItems[0].submenu[3].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[3].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[3].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, refresh } = props;

    const {
        token: {
            pageSize,
            colorPrimary,

        },
    } = theme.useToken();

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.api_key_value.slice(0, 15) + record.api_key_value.slice(-15).replace(/./g, '*'), action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '前缀', dataIndex: 'group_prefix', key: 'group_prefix', },
        { title: '服务代码', dataIndex: 'service_code', key: 'service_code', },
        {
            title: 'ApiKey', key: 'api_key_value',
            render: function (record) {
                return <div style={{
                    color: colorPrimary,
                    cursor: 'pointer'
                }}
                    onClick={(e) => {
                        CopyToClipboard(record.api_key_value);
                        e.preventDefault();
                    }}
                >{record.api_key_value.slice(0, 15) + record.api_key_value.slice(-15).replace(/./g, '*')}</div>
            }
        },
        {
            title: 'ApiSecret', key: 'api_key_secret',
            render: function (record) {
                return <div style={{
                    color: colorPrimary,
                    cursor: 'pointer'
                }}
                    onClick={(e) => {
                        CopyToClipboard(record.api_key_secret);
                        e.preventDefault();
                    }}
                >**********</div>
            }
        },
        { title: '备注', dataIndex: 'description', key: 'description', },
        {
            title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth,
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '', key: 'operation', width: CNF.tableOperationColumnWidth, fixed: 'right', hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation, colorPrimary]);

    return (
        <div>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
        </div>
    );
}

const OrgApiKey = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(CNF.status[0].value);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [serviceCode, setServiceCode] = useState('');

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const handleServiceCodeChange = useCallback((value) => {
        setServiceCode(value);
        setCurrentIndex(1);
    }, []);

    const setOpenModal = useCallback((value, record) => {
        setOpen(value);
        setRecord(record || null);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            service_code: serviceCode,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, serviceCode]);

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Select
                    allowClear
                    placeholder='服务代码'
                    style={{ width: '100%' }}
                    onChange={handleServiceCodeChange}
                    value={serviceCode || undefined}
                    options={(props.serviceCodes || []).map(item => ({
                        value: item,
                        label: item,
                        key: item
                    }))}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    value={status || undefined}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
                serviceCodes={props.serviceCodes}
            />
        </>
    );
}

export default OrgApiKey